// extracted by mini-css-extract-plugin
export default {"dropZoneRoot":"sXbu9","dropZone":"nE_nJ","label":"wwAGz","input":"TKoCf"};